import { useEffect, useState } from "react";

export function InlineNumberEdit({
	value,
	min,
	max,
	onCommit,
}: {
	value: number;
	min: number;
	max: number;
	onCommit: (v: number) => void;
}) {
	const [draft, setDraft] = useState(String(value));
	useEffect(() => {
		setDraft(String(value));
	}, [value]);

	const commit = () => {
		const n = Number(draft);
		if (!Number.isFinite(n) || n < min || n > max) {
			setDraft(String(value));
			return;
		}
		if (n !== value) onCommit(n);
	};

	return (
		<input
			type="number"
			value={draft}
			min={min}
			max={max}
			onChange={(e) => setDraft(e.target.value)}
			onBlur={commit}
			onKeyDown={(e) => {
				if (e.key === "Enter") (e.target as HTMLInputElement).blur();
				if (e.key === "Escape") {
					setDraft(String(value));
					(e.target as HTMLInputElement).blur();
				}
			}}
			className="w-14 rounded border bg-background px-2 py-1 text-right text-xs focus:outline-none focus:ring-1 focus:ring-ring"
		/>
	);
}
